// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"styles_infoIcon__NxEuP"};